import { Component, Input } from '@angular/core';
import { MetaData } from 'situ-warpapi-client';

@Component({
  selector: 'artifact-metadata-menu',
  templateUrl: './artifact-metadata-menu.component.html',
  styleUrls: ['./artifact-metadata-menu.component.scss']
})
export class ArtifactMetadataMenuComponent {
  @Input() isDarkMode: boolean = false;

  entries: MetaData[] = [];

  @Input() set metaData(metaData: MetaData[] | undefined) {
    this.entries = (metaData ?? []).filter(entry => !!entry.key);
  }
}
